import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Restaurant as ServiceIcon } from '@mui/icons-material';
import ModuleHeader from '../../components/ModuleHeader';
import ServiceListTab from './ServiceListTab';
import API from '../../BaseURL';

// ═══════════════════════════════════════════════════════════════════
//  The service list on its own page.
//
//  Same component that sits as the first tab of Daily Collection
//  Balances, but reachable under its own permission key so a cook or
//  counter attendant can be given THIS and not the balances and
//  approvals that live beside it. Giving somebody the serving list
//  should not hand them the school's arrears figures.
// ═══════════════════════════════════════════════════════════════════

export default function ServiceListPage() {
  const [classes, setClasses] = useState([]);
  const [incomeTypes, setIncomeTypes] = useState([]);

  useEffect(() => {
    // Reference data for the two dropdowns. A failure here is not
    // fatal: the list still loads, just without them pre-filled.
    API.get('/classes').then(r => {
      const rows = Array.isArray(r.data) ? r.data : (r.data?.classes || []);
      setClasses(rows.map(c => c.class_name || c.class || c).filter(Boolean));
    }).catch(() => setClasses([]));
    API.get('/collections/income-types').then(r => {
      const rows = Array.isArray(r.data) ? r.data : [];
      setIncomeTypes([...new Set(rows.map(t => t.type).filter(Boolean))]);
    }).catch(() => setIncomeTypes([]));
  }, []);

  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <ModuleHeader
        icon={<ServiceIcon />}
        title="Service List"
        subtitle="Who to serve today — paid in the green list, on credit in the orange list"
      />
      <ServiceListTab classes={classes} incomeTypes={incomeTypes} />
    </Box>
  );
}
